import React, { useState } from 'react';
import Button from 'src/components/Button';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import CalcomConnectionBadge from 'src/components/CalcomConnectionBadge/CalcomConnectionBadge';
import './calcom-connected-card.scss';

interface CalcomConnectedCardProps {
  username: string | null;
  onDisconnect: () => Promise<void>;
}

const CalcomConnectedCard = ({
  username,
  onDisconnect,
}: CalcomConnectedCardProps) => {
  const [isConfirmingDisconnect, setIsConfirmingDisconnect] =
    useState<boolean>(false);
  const [isDisconnecting, setIsDisconnecting] = useState<boolean>(false);

  const handleConfirmDisconnect = async (): Promise<void> => {
    setIsDisconnecting(true);
    await onDisconnect();
    setIsDisconnecting(false);
    setIsConfirmingDisconnect(false);
  };

  return (
    <>
      <div className="card card-wide calcom-connection-status">
        <div className="calcom-connection-status-info">
          <h3 className="card-title">
            <CalcomConnectionBadge isConnected />
          </h3>
          {username && <p className="card-detail">{username}</p>}
        </div>

        <Button
          outline="red"
          size="small"
          onClick={() => setIsConfirmingDisconnect(true)}
        >
          Disconnect
        </Button>
      </div>

      {isConfirmingDisconnect && (
        <ConfirmationModal
          variant="danger"
          title="Disconnect Cal.com?"
          message="Disconnecting won't stop scheduling — new walkthroughs and key pickups will be scheduled natively in Juniper instead of through Cal.com. Any bookings already made through Cal.com will remain, but you won't be able to manage them here anymore."
          confirmLabel="Disconnect"
          cancelLabel="Cancel"
          isSubmitting={isDisconnecting}
          onConfirm={() => handleConfirmDisconnect()}
          onCancel={() => setIsConfirmingDisconnect(false)}
        />
      )}
    </>
  );
};

export default CalcomConnectedCard;
